import "./under-construction.scss";
type UnderConstructionProps = {};

const UnderConstruction = (props: UnderConstructionProps) => {
  return (
    <>
      <div className="page">
        <div className="page__header">
          <h1 className="under-construction page__header__title">СКОРО...</h1>
        </div>
      </div>
    </>
  );
};

export default UnderConstruction;
